// extracted by mini-css-extract-plugin
export default {"controlsButton":"controlsButton__qyiYgt","button":"button__bvcqTS","label":"label__mzIMeY","loading":"loading__mZmwUH","busyMessage":"busyMessage__cmdqFl","beta":"beta___IqcYX"};